import { EnvironmentTypes } from './environmentTypes';

const AppDefaultValuesEnum = {
  LANGUAGE: 'en',
  APPLICATION_ID: process.env.REACT_APP_ENV === EnvironmentTypes.Production ? 107 : 159,
};

Object.freeze(AppDefaultValuesEnum);

export { AppDefaultValuesEnum };
